document.addEventListener('DOMContentLoaded', function () {
  // Accordion
  const titleWrappers = document.querySelectorAll(
    '.cad__section-title-wrapper'
  );

  titleWrappers.forEach((titleWrapper) => {
    titleWrapper.addEventListener('click', function () {
      titleWrapper.classList.toggle('is-open');
    });
  });

  // Dosage per package based on variant
  const productVariantsJSON = document.querySelector(
    '#composition-and-dosage__product-variants'
  )?.textContent;

  try {
    const productVariants = JSON.parse(productVariantsJSON);

    if (!productVariants?.length) {
      return;
    }

    const dosagePerPackage = document.querySelector(
      '[data-dosage-per-package]'
    );
    const dosagePerPackageValue = dosagePerPackage?.querySelector(
      '[data-dosage-per-package-value]'
    );
    const capsulesPerPackage = document.querySelector(
      '[data-capsules-per-package]'
    );
    const capsulesPerPackageValue = capsulesPerPackage?.querySelector(
      '[data-capsules-per-package-value]'
    );
    const mainContainer = document.querySelector(
      '[data-selected-variant-id].f-product-single'
    );

    const updateDosagePerPackage = (variantId) => {
      const selectedVariant = productVariants.find(
        (variant) => variant.id?.toString() === variantId?.toString()
      );

      const dosagePerPackageMetafield =
        selectedVariant?.dosage_per_package ?? '-';

      dosagePerPackageValue.textContent = dosagePerPackageMetafield;
    };

    const updateCapsulesPerPackage = (variantId) => {
      const selectedVariant = productVariants.find(
        (variant) => variant.id?.toString() === variantId?.toString()
      );

      const capsulesPerPackageMetafield = selectedVariant?.capsules_per_package;
      if (capsulesPerPackageMetafield === '-') {
        capsulesPerPackage.style.display = 'none';
      } else {
        capsulesPerPackage.style.display = 'grid';
      }

      capsulesPerPackageValue.textContent = capsulesPerPackageMetafield;
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'data-selected-variant-id'
        ) {
          updateDosagePerPackage(
            parseInt(mainContainer.getAttribute('data-selected-variant-id'))
          );
          updateCapsulesPerPackage(
            parseInt(mainContainer.getAttribute('data-selected-variant-id'))
          );
        }
      });
    });

    observer.observe(mainContainer, {
      attributes: true,
      attributeFilter: ['data-selected-variant-id'],
    });

    updateDosagePerPackage(
      parseInt(mainContainer.getAttribute('data-selected-variant-id'))
    );
  } catch (error) {
    console.error('Error parsing product variants JSON:', error);
  }
});
